module.exports = __webpack_public_path__ + "img/t-22426-004.60ddd3f3.jpg";